import React from 'react'
import { injectIntl } from 'react-intl'

const Address = ({intl}) => (
  <div>
    <h3>Gaijin</h3>

    <address>
      <a href="https://www.google.fi/maps/place/Bulevardi+6,+00120+Helsinki/" rel="noopener noreferrer">Bulevardi 6</a><br />
      00120 Helsinki
    </address>

    <a href="mailto:info@gaijin.fi">info@gaijin.fi</a>
    <a href="tel:+358103229386">{intl.locale==='en'?'+358 ':'0'}10 322 9386</a>

    <a href="https://www.facebook.com/ravintola.gaijin/" className="some facebook">Facebook</a>
    <a href="https://www.linkedin.com/company/bw-restaurants-oy/" className="some linkedin">LinkedIn</a>
  </div>
)

export default injectIntl(Address);


// WEBPACK FOOTER //
// ./src/components/Address.js